import React from 'react';
import { useTranslation } from 'react-i18next';

import { useFilterStatuses } from 'api';
import { filterStatusState } from 'store';
import { ConsultationFilterMultiSelect } from 'components';

export const ConsultationStatusFilter: React.FC = () => {
  const { t } = useTranslation('filter');

  const { data: statusesData } = useFilterStatuses();

  return (
    <ConsultationFilterMultiSelect
      label={t('status_title', 'Status')}
      items={statusesData?.statuses}
      state={filterStatusState}
    />
  );
};
